import React from "react";
import Navbar from './Navbar'

import Project from './Project1'
import { BrowserRouter as Router } from "react-router-dom"
//import { Hashdiv as div } from "react-router-hash-div";


//import g1 from "../img/G1.gif";

import Intro from "./Intro";
import AboutMe from "./AboutMe";
import AllProject from "./AllProject";
import Skills from "./Skills";
import Contact from "./Contact";
import Footer from "./Footer";
import AllP from "./AllP"

const Home = () => {
  return (
    
    
    <div name="home" className="h-screen w-full">
     
     <div id="homenav" smooth><Navbar /></div>
     <div id="homeintro" smooth><Intro /></div>
     <div id="homeabout" smooth><AboutMe /></div> 
     <div id="homeprojects" smooth><AllProject /></div> 
     <div id="homeskills" smooth><Skills /></div> 
     <div id="homecontact" smooth><Contact /></div> 
     <div id="homefooter" smooth><Footer /></div> 
     


      

     
      

      
    </div>
   
  );
};

export default Home;
